import { ObjectSchema, array, object, string, boolean } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { Shipyard } from './../../models/shipyard';
yup.setLocale(locale);

export function shipyardValidator(): ObjectSchema<Shipyard> {
    return object({
        id: string().uuid().strict(),
        name: string().required().nonNullable().strict().max(50),
        iApiCompanyId: string().strict(),
        vessels: array().ensure().required().nonNullable().strict(),
    })
        .strict()
        .noUnknown();
}
